// src/hooks/useBestSellers.js
import { useState, useEffect } from 'react';
import { db } from '../services/firebase';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { useBooks } from './useBooks';

export const useBestSellers = () => {
  const { books: allBooks, loading: booksLoading } = useBooks();
  const [bestSellerIds, setBestSellerIds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBestSellers = async () => {
      try {
        const q = query(collection(db, 'bestSellers'), orderBy('addedAt', 'desc'));
        const snapshot = await getDocs(q);
        const ids = snapshot.docs.map(doc => doc.data().bookId);
        setBestSellerIds(ids);
      } catch (error) {
        console.error('Error fetching best sellers:', error);
        setBestSellerIds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBestSellers();
  }, []);

  // Match IDs with full book data
  const bestSellerBooks = allBooks
    .filter(book => bestSellerIds.includes(book.id))
    // Preserve admin-defined order
    .sort((a, b) => {
      const indexA = bestSellerIds.indexOf(a.id);
      const indexB = bestSellerIds.indexOf(b.id);
      return indexA - indexB;
    });

  return { books: bestSellerBooks, loading: loading || booksLoading };
};